import React from 'react';
('use-client');
import { HStack, useDisclosure, Stack } from '@mybridge/ui';
import { Button } from '@mybridge/ui/button';
import _ from 'lodash';
import { Text } from '@mybridge/ui/text';
import {
  EarthGlobeIcon,
  TeamIcon,
  OnlyMeLockIcon,
  BackArrow,
  ArrowRight,
} from '@mybridge/icons';
import { AudienceFriendsModal } from 'v4/snippets/settings/component/audience-modal-friends';
import { AudienceFriendsListModal } from 'v4/snippets/settings/component/audience-modal-friends-list';
import {
  setAccountPermissions,
  getUserProfileInfo,
} from 'v4/store/actions/user-profile.actions';
import { FindPeopleIcon } from '@mybridge/icons/FindPeopleIcon';
import { useSelector } from 'react-redux';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
const FindPeopleAndContact = () => {
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const userFriendsPermDisc = useDisclosure();
  const userFriendsListPermDisc = useDisclosure();
  const { t } = useTranslator();
  const renderPermissionSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: 'Everyone',
        };
      case 2:
        return {
          icon: <TeamIcon width="16px" height="16px" color="#5B5B5B" />,
          text: 'myNetwork',
        };
      case 3:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: 'Everyone',
        };
    }
  };

  const renderFriendsListSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: '1st Degree',
        };
      case 2:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: '1st Degree',
        };
    }
  };

  const friendReqOption = _.get(
    userProfileInfo,
    'field_audience_visibility.WHO_CAN_SEND_FRIEND_REQ'
  );
  const friendListOption = _.get(
    userProfileInfo,
    'field_audience_visibility.WHO_CAN_SEE_FRIENDS'
  );
  const mentionAndTagsValue = _.get(
    userProfileInfo,
    'field_audience_visibility.MENTIONS_AND_TAGS'
  );

  return (
    <div>
      <Stack spacing="24px" p={['2%', '']} mt={2}>
        {/* Who can send you friend requests? */}
        <HStack
          justifyContent="space-between"
          borderRadius="30px"
          padding="10px"
          border="1px solid #ECECEC"
          height="46px"
        >
          <Text
            lineHeight="19.2px"
            sx={{
              '@media screen and (max-width: 375px)': {
                fontSize: '14px',
              },
            }}
            fontSize="16px"
          >
            {t('settingsAudience.whoCanSendRequests') || "Who can send you friend requests?"}
          </Text>
          <Button
            type="button"
            // borderRadius="50px"
            bg="transparent"
            onClick={() => {
              userFriendsPermDisc.onOpen();
            }}
          >
            <ArrowRight />
          </Button>
        </HStack>

        {/* Who can see your friend list? */}
        <HStack
          justifyContent="space-between"
          height="46px"
          borderRadius="30px"
          padding="10px"
          border="1px solid #ECECEC"
        >
          <Text
            fontSize="16px"
            sx={{
              '@media screen and (max-width: 375px)': {
                fontSize: '14px',
              },
            }}
            lineHeight="19.2px"
          >
            {t('settingsAudience.whoCanSeeFriendList') || "Who can see your friend list?"}
          </Text>
          <Button
            type="button"
            borderRadius="50px"
            bg="transparent"
            onClick={() => {
              userFriendsListPermDisc.onOpen();
            }}
          >
            <ArrowRight />
          </Button>
        </HStack>
      </Stack>
      <AudienceFriendsModal {...userFriendsPermDisc} />
      <AudienceFriendsListModal {...userFriendsListPermDisc} />
    </div>
  );
};

export default FindPeopleAndContact;
